// Handle unauthorized (403) responses for Turbo requests
// Shows a modal instead of replacing content with an error page

import * as bootstrap from "bootstrap"
import { logger } from "./logger"

document.addEventListener("turbo:frame-missing", (event) => {
  // This event fires when a Turbo Frame response doesn't contain the expected frame
  // For 403 responses, we intercept and show a modal instead
  const response = event.detail.response

  if (response && response.status === 403) {
    logger.log("[Turbo Unauthorized] Intercepting 403 response for frame:", event.target.id)

    // Prevent default behavior (showing "Content missing" error)
    event.preventDefault()

    // Show unauthorized modal
    showUnauthorizedModal()
  }
})

document.addEventListener("turbo:before-fetch-response", (event) => {
  // Handle 403 responses before Turbo processes them
  const fetchResponse = event.detail.fetchResponse
  const response = fetchResponse.response

  if (response && response.status === 403) {
    const contentType = response.headers.get("Content-Type") || ""

    logger.log("[Turbo Unauthorized] Got 403 response, contentType:", contentType)

    // If the response is a turbo-stream with our modal, let it through
    if (contentType.includes("text/vnd.turbo-stream")) {
      logger.log("[Turbo Unauthorized] Letting turbo-stream response through")
      return
    }

    // Check if this is a Turbo Frame request
    const turboFrame = event.target.closest("turbo-frame")

    // For any Turbo request (Frame or Stream) that got a non-turbo-stream 403, show modal
    // The turbo:before-fetch-response event only fires for Turbo-initiated requests,
    // so we can safely show the modal for all 403s here
    logger.log("[Turbo Unauthorized] Intercepting 403 for Turbo request, frame:", turboFrame?.id)
    event.preventDefault()
    showUnauthorizedModal()
  }
})

function showUnauthorizedModal() {
  // Get or create the modal container
  let container = document.getElementById("unauthorized_modal_container")

  if (!container) {
    // Create container if it doesn't exist
    container = document.createElement("div")
    container.id = "unauthorized_modal_container"
    document.body.appendChild(container)
  }

  // Create the modal HTML (matching the server-rendered version)
  container.innerHTML = `
    <div class="modal fade" id="unauthorized_modal" tabindex="-1" aria-labelledby="unauthorizedModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header text-bg-dark-secondary border-bottom">
            <h5 class="modal-title text-white" id="unauthorizedModalLabel">
              <i class="fas fa-exclamation-triangle me-2"></i>
              אין הרשאה
            </h5>
            <button type="button" class="btn-close btn-close-white ms-auto" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p class="mb-0">אינך מורשה לבצע פעולה זו</p>
          </div>
          <div class="modal-footer bg-body-secondary border-top">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">סגור</button>
          </div>
        </div>
      </div>
    </div>
  `

  // Show the modal
  const modalElement = document.getElementById("unauthorized_modal")
  const modal = new bootstrap.Modal(modalElement)
  modal.show()

  // Clean up when modal is hidden
  modalElement.addEventListener("hidden.bs.modal", () => {
    container.innerHTML = ""
  }, { once: true })
}
